// extracted by mini-css-extract-plugin
export default {"FS900":"#006700","pricePerServingMessage":"Gbe4ead","oldPrice":"Gb57062","oldPriceInCheckout":"Gff8a70","newPriceInCheckout":"Gc3a8f1","priceMessageInCheckout":"G432569"};